<template>
  <div class="indexPage">
    <div class="head flex-rowl">
      <div class="icon">
        <van-image
          width="100%"
          height="100%"
          :src="require('../../../assets/images/qw_logo.png')"
        />
      </div>
      <div class="main">
        <h1>绑定企微</h1>
        <p>绑定企业微信员工ID</p>
      </div>
    </div>
    <div class="main_wrap">
      <div class="no_wrap" v-if="!isBind">
        <div class="tit flex-rowl">
          <i class="iconfont icon-xingming"></i> 企业微信员工ID：[未绑定]
        </div>
        <div class="custom_btn" @click="handleQueryBind">进行绑定</div>
      </div>
      <div class="have_wrap" v-else>
        <div class="tit flex-rowl">
          <i class="iconfont icon-xingming"></i> 企业微信员工ID：[已绑定]
        </div>
        <div class="txt">
          <h1>[{{qyName}}]</h1>
          <p>{{ $store.state.qy_userId }}</p>
        </div>
        <div class="custom_btn" @click="show = true">解除绑定</div>
      </div>
    </div>
    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
    <!-- 弹窗 -->
    <van-overlay :show="show">
      <div class="popup_wrap">
        <div class="close" @click="show = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
        <!-- 成功 -->
        <div class="success_wrap" v-if="!isBind">
          <h1>绑定成功！</h1>
          <div class="btn" @click="handleBindSuccess">确认</div>
        </div>
        <div class="tip_wrap" v-else>
          <h1>操作确认提示！</h1>
          <div class="txt">
            <p>即将解绑企业微信员工ID关联</p>
            <p>是否确认？</p>
          </div>
          <div class="btn" @click="cancelBind">确认</div>
          <div class="cancel" @click="show = false">取消</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { checkUser, getBind, cancelBind } from "../../../api/qyChat";
export default {
  name: "qyWechat",
  data() {
    return {
      userInfo: "",
      show: false,
      qyName: "",
      // 是否绑定
      isBind: false,
    };
  },
  created() {
    // 判断是否绑定
    this.checkUser();
  },
  methods: {
    handleReturn() {
      this.$router.back();
    },
    checkUser(isShow) {
      let qywx_userid = this.$store.state.qy_userId;
      let openid = this.$store.state.OPENID;
      let params = {
        qywx_userid,
        openid,
      };
      checkUser(params).then((res) => {
        if (res.result && res.message == 1) {
          if (isShow) {
            this.show = true;
          } else {
            this.isBind = true;
          }
        } else {
          this.isBind = false;
          // this.$toast.fail(res.message || '服务器报错，请稍后');
        }

        this.qyName = res.code;
      });
    },
    // 绑定成功
    handleBindSuccess() {
      this.show = false
      setTimeout(() => {
        this.isBind = true
      },200)
    },

    // 确认绑定
    handleQueryBind() {
      let qywx_userid = this.$store.state.qy_userId;
      let openid = this.$store.state.OPENID;
      let params = {
        qywx_userid,
        openid,
      };
      const toast = this.$toast.loading({
        message: "绑定中...",
        forbidClick: true,
      });
      getBind(params).then((res) => {
        if (res.result) {
          setTimeout(() => {
            toast.clear();
            this.checkUser(true);
          }, 500);
        } else {
          toast.clear();
          this.$toast.fail(res.message || '服务器报错，请稍后');
        }
      });
    },

    // 取消绑定
    cancelBind() {
      let qywx_userid = this.$store.state.qy_userId;
      let openid = this.$store.state.OPENID;
      let params = {
        qywx_userid,
        openid,
      };
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      cancelBind(params).then((res) => {
        if (res.result) {
          setTimeout(() => {
            toast.clear();
            this.checkUser();
            this.show = false;
          }, 500);
        } else {
          toast.clear();
          this.$toast.fail(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  height: 100vh;
  background: #fafafa;
  .head {
    padding: 149px 0 31px 77px;
    font-size: 30px;
    color: #333333;
    .icon {
      width: 43px;
      height: 35px;
      margin-right: 19px;
    }
    p {
      margin-top: 7px;
      font-size: 20px;
    }
  }
  .main_wrap {
    background: #fff;
    height: 530px;
    color: #333333;
    padding: 72px 83px;
    box-sizing: border-box;
    font-size: 24px;
    .tit {
      .iconfont {
        font-size: 36px;
        margin-right: 13px;
      }
    }
    .no_wrap {
      .custom_btn {
        margin-top: 160px;
      }
    }
    .have_wrap {
      .txt {
        text-align: center;
        margin: 83px auto 106px;
        p {
          margin-top: 65px;
        }
      }
      .custom_btn {
        margin-top: 0;
      }
    }
    .custom_btn {
      width: 280px;
      height: 50px;
      line-height: 50px;
      font-size: 20px;
    }
  }
  .custom_btn.return {
    margin-top: 70px;
  }
  .popup_wrap {
    width: 550px;
    height: 600px;
    background: #fff;
    font-size: 36px;
    color: #000000;
    text-align: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    .close {
      position: absolute;
      bottom: -80px;
      left: 50%;
      transform: translateX(-50%);
      .iconfont {
        font-size: 52px;
        color: #fff;
      }
    }
    .btn {
      font-size: 22px;
      width: 166px;
      height: 56px;
      line-height: 56px;
      border: 1px solid #969696;
      margin: auto;
      border-radius: 45px;
    }
    .success_wrap {
      h1 {
        padding: 230px 0 110px;
      }
    }
    .tip_wrap {
      h1 {
        padding: 70px 0 77px;
      }
      .txt {
        font-size: 24px;
        p {
          &:last-child {
            margin: 69px auto 79px;
          }
        }
      }
      .cancel {
        font-size: 30px;
        color: #ff0036;
        text-align: center;
        margin-top: 50px;
      }
    }
  }
}
</style>